namespace('compass.tiles');

compass.tiles.SendConfoTileWidget = compass.defineWidget(function SendConfoTileWidget(options) {
	var me = this;
	var $j = jQuery;
	var _dialogId = compass.generateId();

	/* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	this.render = function(widgetElem) {
		widgetElem.append(d.div({ className : 'smallTile tile', tabindex: accessibilty.TAB_INDEX, 'aria-role' : 'button', role : 'button', 'aria-owns':_dialogId},
			d.div({ className : 'smallTileHeader' },
				d.h3({ className : 'headerCopy' }, 'Send New Confirmation'),
				d.div({ className : 'endHeader' })
			),
			d.div({ className : 'smallTileCopy'}, 
				d.span('Email a new hotel confirmation to your existing email or another.&nbsp;&nbsp;'),
				d.span({className : 'newConfoLink link', 'aria-hidden' : 'true'}, "Click here &raquo;")
			)
		));
		widgetElem.activate(function(){
			me.trigger('SendConfoTileWidget.sendConfirmation',{ id: _dialogId });
		});
	};

	var d = $j.dom.getContext(this);
}, {
	GUID : 'defaultSendConfoTileWidgetGUID',
	widgetName : 'SendConfoTileWidget'
});
